import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { FullscreenLoadingComponent } from '../shared/components/fullscreen-loading/fullscreen-loading.component';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private overlayRef: OverlayRef | null = null;

  constructor(private overlay: Overlay) { }

  // use OverlayContainer to create a full-screen loading
  // overlayContainer is part of the Angular CDK
  // it will be above the dialog...
  show() {
    if (!this.overlayRef) {
      const positionStrategy = this.overlay.position().global().centerHorizontally().centerVertically();
      this.overlayRef = this.overlay.create({
        hasBackdrop: true,
        backdropClass: 'cdk-overlay-dark-backdrop',
        positionStrategy,
        scrollStrategy: this.overlay.scrollStrategies.block(),
      });
      const loadingPortal = new ComponentPortal(FullscreenLoadingComponent);
      this.overlayRef.attach(loadingPortal);
    }
  }

  // when switching screens, it still needs to be turned off by code
  hide() {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef = null;
    }
  }
}
